import React, { FC } from 'react';
import cls from './Switcher.module.css';
import classNames from 'classnames';

interface SwitcherProps {
    classes?: string;
    title?: string;
    isActive: boolean;
    onClick: () => void;
    isDisabled?: boolean;
}

export const Switcher: FC<SwitcherProps> = ({
    title,
    isActive,
    onClick,
    isDisabled = false,
    classes,
}) => {
    const handleClick = () => {
        if (!isDisabled) {
            onClick();
        }
    };

    return (
        <div className={classNames(cls.wrapper, classes)}>
            {title && (
                <span className={classNames(cls.title, { [cls.disabled]: isDisabled })}>
                    {title}
                </span>
            )}
            <div
                onClick={handleClick}
                className={classNames(cls.customSwitcher, {
                    [cls.active]: isActive,
                    [cls.disabled]: isDisabled,
                })}
                role="switch"
                aria-checked={isActive}
                aria-disabled={isDisabled}
                tabIndex={isDisabled ? -1 : 0}
                onKeyDown={(e) => {
                    if (!isDisabled && (e.key === 'Enter' || e.key === ' ')) {
                        handleClick();
                    }
                }}
            >
                <input
                    type="checkbox"
                    checked={isActive}
                    readOnly
                    disabled={isDisabled}
                    className={cls.hiddenInput}
                />
                <div className={cls.sliderSwitcher} />
            </div>
        </div>
    );
};
